import { CSSObject } from '@emotion/react';
import React from 'react';
import { detailWrap } from 'styles/table';
import useStatistics from '../useStatistics';

const wrap = (width: number): CSSObject => ({
  display: 'flex',
  flexDirection: 'row',
  marginTop: '24px',
  '> li': {
    width: `${width}%`,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    'p:nth-of-type(1)': {
      fontWeight: 'bold',
      marginBottom: '8px',
      color: '#8d8d8d',
    },
    'p:nth-of-type(2)': {
      '> span': {
        fontSize: '32px',
        fontWeight: 'bold',
      },
    },
  },
  'li + li': {
    borderLeft: '1px solid grey',
  },
});

function Statistics() {
  const {
    enrollCount,
    cancelCount,
    feedbackCount,
    lateOrAbsentCount,
    detailItems,
  } = useStatistics();

  const width = Math.round(100 / (detailItems.length || 4));

  return (
    <div css={[detailWrap, { marginTop: '24px' }]}>
      <h3>행사참여정보</h3>
      <ul css={wrap(width)}>
        <li>
          <p>신청인원</p>
          <p>
            <span>{enrollCount}</span>명
          </p>
        </li>
        <li>
          <p>취소인원</p>
          <p>
            <span>{cancelCount}</span>명
          </p>
        </li>
        <li>
          <p>피드백 작성 인원</p>
          <p>
            <span>{feedbackCount}</span>명
          </p>
        </li>
        <li>
          <p>지각/노쇼</p>
          <p>
            <span>{lateOrAbsentCount}</span>명
          </p>
        </li>
      </ul>
      {detailItems.length > 0 && (
        <>
          <h3>신청상세정보</h3>
          <ul css={wrap(width)}>
            {detailItems.map(({ label, count }, i) => (
              <li key={`${label}-${i}`}>
                <p>{label}</p>
                <p>
                  <span>{count}</span>명
                </p>
              </li>
            ))}
          </ul>
        </>
      )}
    </div>
  );
}

export default Statistics;
